module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main_container"
  }, [_c('section', {
    staticClass: "model_section"
  }, [_c('p', {
    staticClass: "model_top_title"
  }, [_vm._v("新增/编辑优惠券")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "float": "right",
      "margin": "5px 10px 0 0"
    },
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.goback()
      }
    }
  }, [_vm._v("关闭")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between",
      "width": "99%"
    }
  }, [_c('h3', {
    staticStyle: {
      "margin-left": "20px"
    }
  }, [_vm._v("优惠券信息")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.yhqType == '4'),
      expression: "yhqType=='4'"
    }],
    staticStyle: {
      "color": "#F56C6C",
      "margin-top": "20px"
    }
  }, [_vm._v("重要提示：优惠券售价是在用户付费领券后，将售卖款直接奖励给创客。")])]), _vm._v(" "), _c('el-form', {
    attrs: {
      "label-width": "130px"
    }
  }, [_c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.bbNewType == 1),
      expression: "bbNewType == 1"
    }],
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "label": "品类品牌:"
    }
  }, [_c('el-cascader', {
    attrs: {
      "options": _vm.optionsCategoryBrand,
      "placeholder": "请选择品类品牌",
      "filterable": "",
      "clearable": ""
    },
    on: {
      "change": _vm.handleChange
    },
    model: {
      value: (_vm.categoryAndbrand),
      callback: function($$v) {
        _vm.categoryAndbrand = $$v
      },
      expression: "categoryAndbrand"
    }
  })], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "优惠券名称:"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "placeholder": "请输入优惠券名称（10字以内）",
      "maxlength": "10"
    },
    model: {
      value: (_vm.couponname),
      callback: function($$v) {
        _vm.couponname = $$v
      },
      expression: "couponname"
    }
  })], 1)], 1), _vm._v(" "), (_vm.yhqType == '1' || _vm.yhqType == '4') ? _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "售价:"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "placeholder": "请输入优惠券的售价",
      "maxlength": "10",
      "disabled": _vm.seeDis || _vm.IsFree == true,
      "onkeyup": "value=value.replace(/^\\D*(\\d*(?:\\.\\d{0,2})?).*$/g, '$1')"
    },
    model: {
      value: (_vm.Price),
      callback: function($$v) {
        _vm.Price = $$v
      },
      expression: "Price"
    }
  }), _vm._v("  元\r\n        "), _c('el-checkbox', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.yhqType != '4'),
      expression: "yhqType!='4'"
    }],
    staticStyle: {
      "margin-left": "20px"
    },
    on: {
      "change": function($event) {
        return _vm.mianfei()
      }
    },
    model: {
      value: (_vm.IsFree),
      callback: function($$v) {
        _vm.IsFree = $$v
      },
      expression: "IsFree"
    }
  }, [_vm._v("免费")])], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "label": "优惠券面值:",
      "prop": "FaceValue"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "placeholder": "请输入优惠券面值",
      "maxlength": "7",
      "oninput": "value=value.replace(/[^\\d]/g,'')",
      "onkeyup": "value=value.replace(/^\\D*(\\d*(?:\\.\\d{0,2})?).*$/g, '$1')"
    },
    on: {
      "blur": function($event) {
        _vm.FaceValue = $event.target.value
      }
    },
    model: {
      value: (_vm.FaceValue),
      callback: function($$v) {
        _vm.FaceValue = $$v
      },
      expression: "FaceValue"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v("元")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "库存:",
      "prop": "Stock"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "placeholder": "请输入库存",
      "maxlength": "7",
      "onkeyup": "value=value.replace(/[^\\d]/g,'');"
    },
    model: {
      value: (_vm.Stock),
      callback: function($$v) {
        _vm.Stock = $$v
      },
      expression: "Stock"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "使用门槛:",
      "prop": "UseThreshold"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "0"
    },
    model: {
      value: (_vm.singleChoiceWhether),
      callback: function($$v) {
        _vm.singleChoiceWhether = $$v
      },
      expression: "singleChoiceWhether"
    }
  }, [_vm._v(" 无门槛 ")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.singleChoiceWhether),
      callback: function($$v) {
        _vm.singleChoiceWhether = $$v
      },
      expression: "singleChoiceWhether"
    }
  }, [_vm._v("\r\n          满  \r\n          "), _c('el-input', {
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "placeholder": "请输入金额",
      "disabled": _vm.disableThreshold,
      "maxlength": "7",
      "onkeyup": "value=value.replace(/^\\D*(\\d*(?:\\.\\d{0,2})?).*$/g, '$1')"
    },
    model: {
      value: (_vm.UseThreshold),
      callback: function($$v) {
        _vm.UseThreshold = $$v
      },
      expression: "UseThreshold"
    }
  }), _vm._v("\r\n            元  可使用\r\n          ")], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "每人可领取:",
      "prop": "ReceiveNumber"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "disabled": _vm.receiveDisable,
      "maxlength": "7",
      "placeholder": "请输入",
      "onkeyup": "value=value.replace(/[^\\d]/g,'');"
    },
    model: {
      value: (_vm.ReceiveNumber),
      callback: function($$v) {
        _vm.ReceiveNumber = $$v
      },
      expression: "ReceiveNumber"
    }
  }), _vm._v("\r\n          张  \r\n        ")], 1)], 1)], 1), _vm._v(" "), _c('h3', {
    staticStyle: {
      "margin-left": "20px"
    }
  }, [_vm._v("优惠券使用规则")]), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "有效时间："
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "type": "daterange",
      "value-format": "yyyy-MM-dd",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期",
      "picker-options": _vm.pickerOptionsStart
    },
    on: {
      "change": _vm.changeActiveTime
    },
    model: {
      value: (_vm.effectiveTime),
      callback: function($$v) {
        _vm.effectiveTime = $$v
      },
      expression: "effectiveTime"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "label": "特殊说明："
    }
  }, [_c('wjEditor', {
    staticStyle: {
      "width": "90%",
      "margin-bottom": "30px"
    },
    attrs: {
      "desc": _vm.SpecialInstructions
    },
    on: {
      "change": _vm.contentChangeOne
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gudingdibu"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        return _vm.goback()
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    staticClass: "search_btn",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.saveCouponForm()
      }
    }
  }, [_vm._v("保存")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "选择店铺",
      "visible": _vm.dialogVisibledis,
      "width": "40%",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisibledis = $event
      }
    }
  }, [_c('el-form', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "width": "50%",
      "margin-right": "10px"
    },
    attrs: {
      "label": "店铺名称："
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入店铺名称"
    },
    model: {
      value: (_vm.publisherPhone),
      callback: function($$v) {
        _vm.publisherPhone = $$v
      },
      expression: "publisherPhone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.finddes()
      }
    }
  }, [_vm._v("查 询")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "disoutline"
  }, [_vm._l((_vm.desarr), function(item, index) {
    return _c('ul', {
      key: index,
      staticClass: "disinline",
      on: {
        "click": function($event) {
          return _vm.handleGetdesId(item)
        }
      }
    }, [_c('li', [_c('b', [_vm._v(_vm._s(item.name))])]), _vm._v(" "), _c('li', [_vm._v(_vm._s(item.provinceName) + " - " + _vm._s(item.cityName))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(item.phone))]), _vm._v(" "), _c('el-radio', {
      staticClass: "elRadio",
      attrs: {
        "label": item.id
      },
      model: {
        value: (_vm.choiceRadioId),
        callback: function($$v) {
          _vm.choiceRadioId = $$v
        },
        expression: "choiceRadioId"
      }
    }, [_vm._v("选择")])], 1)
  }), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.nofind),
      expression: "nofind"
    }],
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("查无结果")])], 2), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogVisibledis = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.makedes()
      }
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5f97f1b3!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/operationManagement/couponAdd.vue
// module id = 1701
// module chunks = 3